// Onboarding gate: mandatory profile fields per role.
const hasText = (v) => typeof v === "string" && v.trim().length > 0;
const hasItems = (v) => Array.isArray(v) && v.length > 0;

export function isProfileComplete(user) {
  if (!user || !user.role) return false;
  const p = user.profile || {};
  if (user.role === "creator") {
    return hasText(p.bio) && hasText(p.location) && hasItems(p.categories) && hasItems(p.content_types);
  }
  // business
  return hasText(p.company_name) && hasText(p.industry) && hasText(p.description) && hasText(p.contact_person);
}
